import * as yup from "yup";
import { QSNetworkFormValues } from "./@types/QSNetworkFormValues";
import { extractNetworkReferencesFromQuickSearchInput } from "./utils";
import {
  NETWORK_SEARCH_LIMIT,
  NETWORK_SEARCH_LIMIT_ERROR_MESSAGE
} from "../../../consts";

export const NETWORK_VALIDATION_SCHEMA = yup
  .object<QSNetworkFormValues>()
  .shape({
    urlDomainIP: yup
      .string()
      .required("Please enter at least one URL, Domain or IP Address")
      .test({
        name: "urlDomainIP_custom_should_be_valid",
        test(value: string) {
          const netRefs = extractNetworkReferencesFromQuickSearchInput(value);

          if (netRefs.length === 0)
            return this.createError({
              message: "Please enter at least one URL, Domain or IP Address.",
              path: "urlDomainIP"
            });

          if (netRefs.length > NETWORK_SEARCH_LIMIT)
            return this.createError({
              message: NETWORK_SEARCH_LIMIT_ERROR_MESSAGE,
              path: "urlDomainIP"
            });

          return true;
        }
      }),
    classification: yup.object().shape({
      label: yup.string(),
      value: yup.string()
    }),
    resourceType: yup.object().shape({
      label: yup.string(),
      value: yup.string()
    }),
    firstSeen: yup
      .object()
      .shape({
        label: yup.string(),
        value: yup.string()
      })
      .test({
        name: "firstSeen_custom_timerange_should_be_valid",
        message: "First seen time custom time range should be valid!",
        test(value: { label: string; value: string }) {
          if (value.label !== "custom") return true;

          const [from, to] = value.value.split(" TO ");
          const fromTime = new Date(from.slice(1)).getTime();
          const toTime = new Date(to.slice(0, -1)).getTime();

          return fromTime <= toTime;
        }
      })
  });
